import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { logoutProcessor } from "./helpers/logoutProcessor";
import { useTranslation } from "../i18n";
import { apiFetch } from "../api/apiFetch";

type orderDetails = {
    Datetime: string,
    Warehouse: string,
    Bay: string,
    OrderNumber: string,
    Locations: string[],
    ItemSkus: string[],
    NumberOfItems: number,
    Collected: boolean,
    Tag: string,
    SentToPPd: boolean
}

type searchItem = {
    Day: string,
    Warehouse: string,
    Batch: number,
    OrderNumber: string,
    OrderType: string | null,
    ItemSku: string,
    Sorter1Location: number,
    Sorter1Scanned: boolean,
    Sorter2LocationsNeeded: number,
    Sorter2Location: string[],
    Sorter2Scanned: boolean,
    Status: string,
    SentToPPd: boolean,
    PPdTag: string,
    OrderDetails: orderDetails | null
}



const ZoneStorageSettingsSearch = ({ warehouse }: { warehouse: string }) => {

    const navigator = useNavigate();
    const { t } = useTranslation();

    const [searchEntry, set_searchEntry] = useState<string>("");
    const [searchedItem, set_searchedItem] = useState<string>("");
    const [searchLoading, set_searchLoading] = useState<boolean>(false);
    const [searchResults, set_searchResults] = useState<{ item: searchItem[] }>();
    const [errorText, set_errorText] = useState<string>("");


    const searchSubmit = async () => {
        if (searchLoading === true || searchEntry === "") {
            return;
        }

        // Show user it is searching
        set_searchLoading(true);

        // Get item to search
        const itemToSearch = searchEntry;
        set_searchEntry("");

        console.log(searchEntry);

        // Search for item
        await apiFetch(`/zonestorage/settings/item-search`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ warehouse: warehouse, itemSku: itemToSearch })
        }).then(async (res): Promise<any> => {
            const response = await res.json();

            set_searchResults({ item: [] });
            set_searchedItem(itemToSearch);

            if (res.ok) {
                console.log("Found");
                console.log(response);
                set_errorText("");
                set_searchResults(response);
            } else if (res.status === 404) {
                console.log("Item not found");
                set_errorText(t("item_not_found"));
            } else if (res.status === 401) {
                console.log("INVALID PERMISSIONS");
                logoutProcessor();
                navigator("/login");
            } else {
                console.log("ERROR");
                set_errorText(response);
            }
        });

        // Finish showing user it is searching
        set_searchLoading(false);
    }

    return (
        <div className="zs-card">
            <h2 className="zs-card-title">{t("item_search")}</h2>
            <form className="settings-item-search-form" onSubmit={(e) => { e.preventDefault(); searchSubmit() }}>
                <input type="text" placeholder={t("search_label")} value={searchEntry} onChange={(e) => set_searchEntry(e.target.value)} />
                <button type="submit">{searchLoading ? t("searching") : t("search")}</button>
            </form>

            {searchedItem && (
                <div className="search-results-section">
                    <p className="search-results-label">{t("item")}: <strong>{searchedItem}</strong></p>

                    {errorText !== "" && (
                        <p className="search-error-text">{errorText}</p>
                    )}

                    {(searchResults?.item != undefined && searchResults?.item.length > 0) &&
                        searchResults?.item.map((batchDetails) => (
                            <div key={batchDetails.Batch + batchDetails.Day} className="search-result-card">
                                <div className="search-result-header">
                                    <span>{t("date_label", { date: new Date(batchDetails.Day).toLocaleDateString('en-GB') })}</span>
                                    <span>{t("batch_label", { batch: String(batchDetails.Batch) })}</span>
                                    <span>{batchDetails.OrderNumber === "" ? "" : `#${batchDetails.OrderNumber}`}</span>
                                    <span>{batchDetails.OrderType !== undefined ? batchDetails.OrderType : ""}</span>
                                    <span className="search-result-status">{batchDetails.Status}</span>
                                </div>

                                <div className="search-result-body">
                                    <div className="search-result-col">
                                        <h4>{t("sorter_1")}</h4>
                                        <p>{t("sorter_1_scanned", { value: batchDetails.Sorter1Scanned.toString().toUpperCase() })}</p>
                                        <p>{t("sorter_1_lane", { lane: String(batchDetails.Sorter1Location) })}</p>
                                    </div>

                                    <div className="search-result-col">
                                        <h4>{t("sorter_2")}</h4>
                                        <p>{t("sorter_2_scanned", { value: batchDetails.Sorter2Scanned.toString().toUpperCase() })}</p>
                                        <p>{t("sorter_2_locations_needed", { count: String(batchDetails.Sorter2LocationsNeeded) })}</p>
                                        <p>{t("sorter_2_locations", { locations: typeof batchDetails.Sorter2Location == "string" ? "N/A" : batchDetails.Sorter2Location.join(", ") })}</p>
                                    </div>
                                </div>

                                {(batchDetails.OrderDetails === null && batchDetails.Sorter2LocationsNeeded > 0) && (
                                    <div className="search-result-order">
                                        <h4>{t("order_details")}</h4>
                                        <p>{t("order_not_ready")}</p>
                                    </div>
                                )}

                                {batchDetails.OrderDetails !== null && (
                                    <div className="search-result-order">
                                        <h4>{t("order_details")}</h4>
                                        <p>{t("number_items", { count: String(batchDetails.OrderDetails.NumberOfItems) })} &middot; {t("collected_label", { value: batchDetails.OrderDetails.Collected.toString().toUpperCase() })} &middot; {t("tag_label", { tag: batchDetails.OrderDetails.Tag === "" ? "N/A" : batchDetails.OrderDetails.Tag })} &middot; {t("sent_to_ppd", { value: batchDetails.OrderDetails.SentToPPd.toString().toUpperCase() })}</p>
                                    </div>
                                )}
                            </div>
                        ))
                    }
                </div>
            )}
        </div>
    );
};

export default ZoneStorageSettingsSearch;
